module.exports = __webpack_public_path__ + "static/media/hall-P6.99255745.svg";